import { render, staticRenderFns } from "./custom-switch.vue?vue&type=template&id=7451b91a&"
import script from "./custom-switch.vue?vue&type=script&lang=js&"
export * from "./custom-switch.vue?vue&type=script&lang=js&"
import style0 from "./custom-switch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports